import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import RecommendedArticles from '@components/SideFeedItems/RecommendedArticles';
import Spinner from '@components/Spinner';
import useArticlesBySlug from '@hooks/useArticlesBySlug';
import { Theme } from '@interfaces/global';
import { TrackingLocation } from '@tracking';

import { LeadCaptureModalBodyProps } from '../LeadCaptureModalBody';
import LeadCaptureModalBody from '../LeadCaptureModalBody';
import { ModalHeaderProps } from '../common/modalHeader';

export type LeadCaptureWithArticlesProps = ModalHeaderProps & LeadCaptureModalBodyProps;

const LeadCaptureModalWithVerticalArticles = ({
  articleSlugs,
  articleTitleSection = 'Most Popular',
  highlight,
  title,
  subtitle,
  buttonText,
  leadType,
  offerLink,
  offerCode,
  modalId,
  modalType,
}: LeadCaptureWithArticlesProps) => {
  const { data: articles, isLoading } = useArticlesBySlug({ articleSlugs });

  const utmParams = {
    utm_source: 'bc_modal',
    utm_campaign: modalType,
    utm_content: modalId,
  };

  return (
    <div className="flex w-full flex-wrap">
      <div className="w-full border-0 border-b border-solid md:w-7/12 md:border-b-0 md:border-r ">
        <div className="py-48 pl-48 pr-48 md:py-72 md:pl-64 md:pr-0">
          {highlight && (
            <span className="mb-8 font-suisse-intl-mono text-overline-sm text-primary-magenta sm:text-overline-md">
              {highlight}
            </span>
          )}
          <h2 className="my-0 max-w-[505px] font-suisse-works text-headline-sm sm:text-headline-xl ">
            {ReactHtmlParser(title)}
          </h2>
          <p className="my-0 mb-32 font-suisse-intl text-description-sm sm:mb-48 sm:text-description-lg">
            {ReactHtmlParser(subtitle)}
          </p>
          <div className="w-full sm:w-[370px]">
            <LeadCaptureModalBody
              buttonText={buttonText}
              leadType={leadType}
              offerLink={offerLink}
              theme={Theme.Light}
              withOauth={false}
            />
          </div>
        </div>
      </div>
      <div className="mt-32 flex w-full flex-col items-center justify-center md:ml-72 md:w-auto">
        <div className="w-[330px] border-0 border-b border-solid border-grayscale-gray">
          <div className=" mb-4 font-suisse-intl-mono text-body-md text-primary-magenta">
            {articleTitleSection}
          </div>
        </div>
        {isLoading ? (
          <Spinner />
        ) : (
          <div className="max-w-[330px]">
            <RecommendedArticles
              recommendedArticles={articles}
              skipSectionTitle
              trackingLocation={TrackingLocation.Modal}
              className="!mb-0 mt-24"
              offerCode={offerCode}
              utmParams={utmParams}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default LeadCaptureModalWithVerticalArticles;
